import { defineComponent as _defineComponent } from 'vue'
import { computed, PropType, watch } from 'vue';
import { templateRef } from '@vueuse/core';
import { User } from '@/models/User';
import { ChatGroupMember } from '@/models/Messenger';
import userFromState from '@/state/messenger/userFromState';
import store from '@/store';
import BCXMessengerUserSelectItem from '@/components/messenger/User/BCXMessengerUserSelectItem.vue';
import useQuickInfo from '@/state/quickInfo';
import RemoveIcon from '@/components/svg/x-circle-2.svg?inline';


export default /*#__PURE__*/_defineComponent({
  __name: 'BCXMessengerChatGroupMember',
  props: {
  member: {
    type: Object as PropType<ChatGroupMember>,
    required: true
  },
  removable: Boolean
},
  emits: ['remove'],
  setup(__props) {

const props = __props;





const anchor = templateRef<HTMLElement>('anchor');
const { showQuickInfo } = useQuickInfo();

const displayUser = computed<User>(() => userFromState(props.member.user));

// The banner cache omits city/company — load the full quick-profile for this member.
watch(() => props.member.user, (userId) => {
  if (userId) store.dispatch('userStates/requestQuickProfile', userId);
}, { immediate: true });

const isPending = computed(() => props.member.state === 'INVITED');

const openQuickInfo = () => showQuickInfo(anchor, displayUser.value);

return { __sfc: true,props, anchor, showQuickInfo, displayUser, isPending, openQuickInfo, BCXMessengerUserSelectItem, RemoveIcon }
}

})